// Module
var code = `<base-button btn-type="{{btnType}}" btn-size="{{btnSize}}" btn-context="{{btnContext}}" type="{{type}}"> <i class="fa fa-plus"></i> <span ng-if="!btnIconOnly">{{ 'Generic.Create' | translate }}</span> </base-button> `;
// Exports
module.exports = code;